var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDtmfHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,64c2.9,0,5.8-0.4,8.5-1.1s5.3-1.8,7.6-3.2s4.5-3.1,6.5-5s3.6-4.1,5-6.5s2.5-4.9,3.2-7.6S64,34.9,64,32s-0.4-5.8-1.1-8.5 s-1.8-5.3-3.2-7.6s-3.1-4.5-5-6.5s-4.1-3.6-6.5-5s-4.9-2.5-7.6-3.2S34.9,0,32,0s-5.8,0.4-8.5,1.1S18.2,3,15.9,4.4s-4.5,3.1-6.5,5 s-3.6,4.1-5,6.5s-2.5,4.9-3.2,7.6S0,29.1,0,32s0.4,5.8,1.1,8.5s1.8,5.3,3.2,7.6s3.1,4.5,5,6.5s4.1,3.6,6.5,5s4.9,2.5,7.6,3.2 S29.1,64,32,64z M32,4c2.6,0,5.1,0.3,7.5,1s4.6,1.6,6.7,2.8s4,2.7,5.7,4.4s3.2,3.6,4.4,5.7s2.2,4.3,2.8,6.7s1,4.9,1,7.5 s-0.3,5.1-1,7.5s-1.6,4.6-2.8,6.7s-2.7,4-4.4,5.7s-3.6,3.2-5.7,4.4s-4.3,2.2-6.7,2.8s-4.9,1-7.5,1s-5.1-0.3-7.5-1s-4.6-1.6-6.7-2.8 s-4-2.7-5.7-4.4S9,48.2,7.8,46.1S5.7,41.8,5,39.5S4,34.6,4,32s0.3-5.1,1-7.5s1.6-4.6,2.8-6.7s2.7-4,4.4-5.7s3.6-3.2,5.7-4.4 s4.3-2.2,6.7-2.8S29.4,4,32,4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.9,23.9l2-9.4H38l-2,9.4h-5.9l2-9.4h-3l-2,9.4h-6.5l-0.5,2.5h6.5l-1.4,7H19l-0.5,2.5h6.1l-2,9.3h2.9l2-9.3h5.9l-2,9.3h3 l2.1-9.3h6.4l0.6-2.5H37l1.5-7h6.1l0.5-2.5H38.9z M34,33.4h-6l1.5-7h5.9L34,33.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtmfHash);
export default __webpack_public_path__ + "static/media/dtmf-hash.11719dc3.svg";
export { ForwardRef as ReactComponent };